import * as React from 'react';
import { composeRef } from 'rc-util/lib/ref';
const Input = ({ prefixCls, id, inputElement, disabled, tabIndex, autoFocus, autoComplete, editable, accessibilityIndex, value, maxLength, onKeyDown, onMouseDown, onChange, onPaste, onCompositionStart, onCompositionEnd, open, attrs }, ref) => {
    let inputNode = inputElement || <input />;
    const { ref: originRef, props: { onKeyDown: onOriginKeyDown, onChange: onOriginChange, onMouseDown: onOriginMouseDown, onCompositionStart: onOriginCompositionStart, onCompositionEnd: onOriginCompositionEnd, style } } = inputNode;
    inputNode = React.cloneElement(inputNode, Object.assign(Object.assign({ id, ref: composeRef(ref, originRef), disabled,
        tabIndex, autoComplete: autoComplete || 'off', type: 'search', autoFocus, className: `${prefixCls}-selection-search-input`, style: Object.assign(Object.assign({}, style), { opacity: editable ? null : 0 }), role: 'combobox', 'aria-expanded': open, 'aria-haspopup': 'listbox', 'aria-owns': `${id}_list`, 'aria-autocomplete': 'list', 'aria-controls': `${id}_list`, 'aria-activedescendant': `${id}_list_${accessibilityIndex}` }, attrs), { value: editable ? value : '', maxLength, readOnly: !editable, unselectable: !editable ? 'on' : null, onKeyDown: (event) => {
            onKeyDown(event);
            if (onOriginKeyDown) {
                onOriginKeyDown(event);
            }
        }, onMouseDown: (event) => {
            onMouseDown(event);
            if (onOriginMouseDown) {
                onOriginMouseDown(event);
            }
        }, onChange: (event) => {
            onChange(event);
            if (onOriginChange) {
                onOriginChange(event);
            }
        }, onCompositionStart(event) {
            onCompositionStart(event);
            if (onOriginCompositionStart) {
                onOriginCompositionStart(event);
            }
        },
        onCompositionEnd(event) {
            onCompositionEnd(event);
            if (onOriginCompositionEnd) {
                onOriginCompositionEnd(event);
            }
        },
        onPaste }));
    return inputNode;
};
const RefInput = React.forwardRef(Input);
RefInput.displayName = 'Input';
export default RefInput;
